
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"32","height":"32","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#373846","d":"M28.25 0H3.75A3.754 3.754 0 000 3.75v24.5A3.754 3.754 0 003.75 32h24.5A3.754 3.754 0 0032 28.25V3.75A3.754 3.754 0 0028.25 0zm1.25 28.25c0 .69-.56 1.25-1.25 1.25h-7.125V19.312h3.862l.638-3.875h-4.5V12.75c0-1.06.814-1.875 1.875-1.875h2.563V7H23a5.749 5.749 0 00-5.749 5.76v2.678H13.5v3.874h3.751V29.5H3.75c-.69 0-1.25-.56-1.25-1.25V3.75c0-.69.56-1.25 1.25-1.25h24.5c.69 0 1.25.56 1.25 1.25v24.5z"}})])
          )
        }
      }
    